import { DataTypeColumn } from 'components/DataExpansionComponents/Common/commonColumnHelpers'

type RebateEnrollmentColumn =
  | 'tradespend_user_name'
  | 'company_name'
  | 'total_claims'
  | 'pending_validation_claims'
  | 'invalid_claims'
  | 'unpaid_valid_claims'
  | 'paid_claims'
  | 'total_validated_units'
  | 'total_validated_payout'
  | 'created'

export const REBATE_ENROLLMENT_COLUMNS: Record<
  RebateEnrollmentColumn,
  DataTypeColumn
> = {
  tradespend_user_name: {
    header: 'User',
    group: 'User Information',
  },
  company_name: {
    header: 'Company',
    group: 'User Information',
  },
  total_claims: {
    header: 'Total Claims',
    group: 'Claims',
  },
  pending_validation_claims: {
    header: 'Claims Pending Validation',
    group: 'Claims',
  },
  invalid_claims: {
    header: 'Invalid Claims',
    group: 'Claims',
  },
  unpaid_valid_claims: {
    header: 'Unpaid Valid Claims',
    group: 'Claims',
  },
  paid_claims: {
    header: 'Paid Valid Claims',
    group: 'Claims',
  },
  total_validated_units: {
    header: 'Total Valid Units',
    group: 'Validated Data',
  },
  total_validated_payout: {
    header: 'Total Valid Payout',
    group: 'Validated Data',
  },
  created: {
    header: 'Enrolled On',
    group: 'Enrollment Date',
  },
}
